import { render, staticRenderFns } from "./Mortgage.vue?vue&type=template&id=2560a8a9&scoped=true"
import script from "./Mortgage.vue?vue&type=script&lang=js"
export * from "./Mortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2560a8a9",
  null
  
)

export default component.exports